import dayjs from 'dayjs';

import { ChatProps } from '@speeki/chat-web-components';
import { useParticipantsContext } from '@speeki/firebase-chat';

const TIME_TO_SET_OFFLINE = 6;

export const useUserActivity = () => {
    const users = useParticipantsContext();

    const getActivity: ChatProps['getActivity'] = (userId) => {
        const user = users[userId];

        if (user?.lastActive) {
            const { lastActive } = user;
            const userActive = dayjs(lastActive.toDate());
            const isActive =
                dayjs().diff(userActive, 'minutes', true) < TIME_TO_SET_OFFLINE;
            return { isActive, userActive };
        }

        return { isActive: false };
    };

    return { getActivity };
};
